import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-02069d63"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "smart-cs-chat-dialog"
}
const _hoisted_2 = { class: "chat-header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "chat-header-title" }, "智能客服", -1))
const _hoisted_4 = {
  key: 0,
  class: "chat-header-tip"
}
const _hoisted_5 = {
  class: "chat-messages",
  ref: "messagesContainer"
}
const _hoisted_6 = {
  key: 0,
  class: "chat-loading"
}
const _hoisted_7 = { class: "message-avatar" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { key: 2 }
const _hoisted_11 = { class: "message-bubble" }
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = { class: "message-time" }
const _hoisted_14 = {
  key: 1,
  class: "chat-message message-system"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "message-avatar" }, [
  /*#__PURE__*/_createElementVNode("span", null, "AI")
], -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "message-bubble" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "message-content typing-indicator" }, [
    /*#__PURE__*/_createElementVNode("span"),
    /*#__PURE__*/_createElementVNode("span"),
    /*#__PURE__*/_createElementVNode("span")
  ])
], -1))
const _hoisted_17 = [
  _hoisted_15,
  _hoisted_16
]
const _hoisted_18 = { class: "chat-input-area" }
const _hoisted_19 = ["disabled"]
const _hoisted_20 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.visible)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          (_ctx.humanServiceUrl)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createTextVNode(" 若您需要省区客服直接对接，可 "),
                _createElementVNode("a", {
                  class: "human-service-link",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openHumanService && _ctx.openHumanService(...args)))
                }, "点击人工客服")
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            class: "chat-close-btn",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onClose && _ctx.onClose(...args)))
          }, "×")
        ]),
        _createElementVNode("div", _hoisted_5, [
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, "加载中..."))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messages, (msg, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: _normalizeClass(["chat-message", {
          'message-customer': msg.senderType === 'CUSTOMER',
          'message-ai': msg.senderType === 'AI',
          'message-system': msg.senderType === 'SYSTEM'
        }])
            }, [
              _createElementVNode("div", _hoisted_7, [
                (msg.senderType === 'CUSTOMER')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_8, "我"))
                  : (msg.senderType === 'AI')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_9, "AI"))
                    : (_openBlock(), _createElementBlock("span", _hoisted_10, "ⓘ"))
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", {
                  class: "message-content",
                  innerHTML: _ctx.renderMarkdown(msg.messageContent)
                }, null, 8, _hoisted_12),
                _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.formatTime(msg.sendTime)), 1)
              ])
            ], 2))
          }), 128)),
          (_ctx.sending)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, _hoisted_17))
            : _createCommentVNode("", true)
        ], 512),
        _createElementVNode("div", _hoisted_18, [
          _withDirectives(_createElementVNode("textarea", {
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.inputText) = $event)),
            class: "chat-input",
            placeholder: "请输入您的问题...",
            onKeydown: _cache[3] || (_cache[3] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.onSend && _ctx.onSend(...args)), ["exact","prevent"]), ["enter"])),
            disabled: _ctx.sending,
            rows: "2"
          }, null, 40, _hoisted_19), [
            [_vModelText, _ctx.inputText]
          ]),
          _createElementVNode("button", {
            class: "chat-send-btn",
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onSend && _ctx.onSend(...args))),
            disabled: _ctx.sending || !_ctx.inputText.trim()
          }, " 发送 ", 8, _hoisted_20)
        ])
      ]))
    : _createCommentVNode("", true)
}